export const enum SCAFFOLDTYPES {
  FRAME = "frame",
  MODULE = "module",
}
